import { Component, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ImageService } from '../../services/image/image.service';
import { Subscription } from 'rxjs/Subscription';

declare var Cropper;

@Component({
  selector: 'tog-content-image-cropper',
  templateUrl: './content-image-cropper.component.html',
  styleUrls: ['./content-image-cropper.component.scss']
})
export class ContentImageCropperComponent implements OnDestroy {
  @Input() allowDroppingFiles: boolean = false;
  @Input() rounded: boolean = false;
  @Input() name: string = '';

  initialized: boolean = false;
  fileReader: FileReader = new FileReader();
  backgroundImageSrc: string = '';
  activeImage: HTMLImageElement;
  rotatedImage: string = '';
  initialAspectRatio: number;
  cropper: any;

  @ViewChild('imageToCrop') imageToCrop: ElementRef;

  imageServiceSubscription: Subscription;

  constructor(public imageService: ImageService) {
    imageService.imageSelected.subscribe(e => {
      if (e && e.name && e.name === this.name) this.initializeCropper(e.image);
    });
  }

  initializeCropper(image: HTMLImageElement) {
    this.activeImage = image;

    // Need to wait 1 tick for angular to place the image element in the DOM
    setTimeout(() => {
      if (this.cropper) {
        this.cropper.replace(this.activeImage.src);
      } else {
        this.cropper = new Cropper(this.imageToCrop.nativeElement, {
          minContainerWidth: 475,
          minContainerHeight: 250,
          zoomOnWheel: false,
          zoomOnTouch: false
        });
        if (this.initialAspectRatio) this.cropper.setAspectRatio(this.initialAspectRatio);
      }

      if (this.rounded) this.setAspectRatioFromDimensions(1, 1);
      this.initialized = true;
    });
  }

  setAspectRatioFromDimensions(width: number, height: number) {
    if (this.cropper) {
      this.cropper.setAspectRatio(width / height);
    } else this.initialAspectRatio = width / height;
  }

  rotate(deg: number = 90) {
    this.cropper.rotate(deg);
  }

  save() {
    let canvas = this.cropper.getCroppedCanvas({
      width: 600,
      imageSmoothingEnabled: false,
      imageSmoothingQuality: 'high',
    });

    this.imageService.setCroppedImage(canvas, this.name);
  }

  ngOnDestroy() {
    if (this.cropper) this.cropper.destroy();
    if (this.imageServiceSubscription) this.imageServiceSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/content-image-cropper/content-image-cropper.component.ts